import { ANALYTICS_SOURCE } from './analytics.ts';

export type HubDependency =
	| 'agentContributors'
	| 'agentViewers'
	| 'agentViewerAccess'
	| 'jiraMetadataAggregate'
	| 'smartLink'
	| 'siteTraits';

export type DependencyOperation =
	| 'read'
	| 'resolve'
	| 'refresh'
	| 'connectorAuthRates'
	| 'smartLinkCounts'
	| 'connectedAppsRates';

export type DependencyOutcome =
	| 'succeeded'
	| 'empty'
	| 'partial'
	| 'failed'
	| 'cancelled'
	| 'denied'
	| 'unsupported'
	| 'unavailable'
	| 'timeout';

export type DependencyHealthDetails = {
	resultSource?: 'store' | 'client' | 'unsupportedCache';
	errorType?: 'network' | 'client' | 'server' | 'parse' | 'unknown';
};

export type DependencyHealthAttributes = DependencyHealthDetails & {
	dependency: HubDependency;
	operation: DependencyOperation;
	outcome: DependencyOutcome;
	durationMs?: number;
};

export type DependencyHealthReporter = (attributes: DependencyHealthAttributes) => void;

export type DependencyHealthEvent = {
	readonly type: 'sendOperationalEvent';
	readonly data: {
		readonly action: 'observed';
		readonly actionSubject: 'hubDependency';
		readonly source: 'byline-connections';
		readonly attributes: DependencyHealthAttributes;
	};
};

export const getDependencyHealthEvent = (
	attributes: DependencyHealthAttributes,
): DependencyHealthEvent => ({
	type: 'sendOperationalEvent',
	data: {
		action: 'observed',
		actionSubject: 'hubDependency',
		source: ANALYTICS_SOURCE,
		attributes,
	},
});
